var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeBrandsSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 538.26576 390.51117",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 538.26576,64.784864 c -6.3,-23.7 -24.8,-42.3 -48.3,-48.6 -42.6,-11.5 -213.4,-11.5 -213.4,-11.5 0,0 -170.8,0 -213.400003,11.5 -23.5,6.3 -42,24.9 -48.3,48.6 C 3.4657568,107.68486 3.4657568,197.08486 3.4657568,197.08486 c 0,0 0,89.4 11.4000002,132.3 6.3,23.7 24.8,41.5 48.3,47.8 42.600003,11.5 213.400003,11.5 213.400003,11.5 0,0 170.8,0 213.4,-11.5 23.5,-6.3 42,-24.2 48.3,-47.8 11.4,-42.9 11.4,-132.3 11.4,-132.3 0,0 0,-89.4 -11.4,-132.299996 z m -317.5,213.499996 v -162.4 l 142.7,81.2 z",
    id: "path1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeBrandsSolid);
export default __webpack_public_path__ + "static/media/youtube-brands-solid.04e8299bfe3703c97d06886b79556b8d.svg";
export { ForwardRef as ReactComponent };